import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import App from './app';
import {createElementWithContext} from 'fluxible-addons-react';

const dehydratedState = window.Banquet;
const app = new App({});
app.rehydrate(dehydratedState, (error, context) => {
  if(error) {throw error;}
  window.context = context;
  const mountNode = document.getElementById('app');
  render(createElementWithContext(context), mountNode);
});



// WEBPACK FOOTER //
// banquet/banquet.js